/**
 * @generated SignedSource<<889b4840c1438ff31a8a6f8b1b44afb0>>
 * @relayHash 5768646120752803cfd8a2e97cafc292
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81b380d431b5fe2a18a3e04e8c25d423b6729969a77278a2d46b3713e4f4ecb8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { hubHomeContentWrapperQuery } from './hubHomeContentWrapperQuery.graphql';

const node: PreloadableConcreteRequest<hubHomeContentWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "81b380d431b5fe2a18a3e04e8c25d423b6729969a77278a2d46b3713e4f4ecb8",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
